import { render, staticRenderFns } from "./PersonalDataAgreement.vue?vue&type=template&id=57f567da&"
import script from "./PersonalDataAgreement.vue?vue&type=script&lang=js&"
export * from "./PersonalDataAgreement.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataAgreement.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/PersonalDataAgreement.vue
// module id = 431
// module chunks = 0